<template lang="pug">
  tr(class="v-data-table__mobile-row__tr")
    td(
      class="v-data-table__mobile-row__td"
      v-on="wrappedListeners"
    )
      div(
        class="content"
        :class="{ 'no-icon': !config.icon }"
      )
        div(
          v-if="config && config.icon"
          class="icon-wrapper"
        )
          e-svg-icon(:name="config.icon")
        div
          div(
            v-if="title"
            class="text-14px dark wb-bw"
          ) {{ title }}
          component(
            v-if="subtitle && subtitle.component"
            :is="subtitle.component"
            :value="subtitle.value"
            v-bind="subtitle.componentProps"
            class="text-12px"
          )
          div(
            v-else-if="subtitle && !subtitle.component"
            class="text-12px"
          ) {{ subtitle }}
          div(
            v-if="additionalData"
            class="text-12px light d-flex align-center"
          )
            div(
              v-for="(item, idx) in additionalData"
              :key="idx"
            )
              span {{ handleValue(item, scopedItem.item) }}
              span(
                v-if="idx !== additionalData.length - 1"
                class="text-12px light"
              ) ・
        t-orm-table-actions(
          :actions="actions"
          :item="scopedItem.item"
          :activator-options="{ small: true }"
        )
</template>

<script>
import TOrmTableActions from '~/components/templates/orm/t-orm-table-actions'
import EDocumentsStatus from '~/modules/documents/components/elements/e-documents-status'
import EStatusChip from '~/components/elements/e-status-chip'

export default {
  name: 'TTableRowMobile',
  components: {
    TOrmTableActions,
    EDocumentsStatus,
    EStatusChip
  },
  props: {
    scopedItem: {
      type: Object,
      default: () => ({})
    },
    actions: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    title() {
      if (!this.config || !this.config.title) {
        return
      }
      return this._.get(this.scopedItem.item, this.config.title) || this.config.title
    },
    subtitle() {
      if (!this.config || !this.config.subtitle) {
        return
      }
      if (this._.isObject(this.config.subtitle)) {
        return {
          ...this.config.subtitle,
          value: this._.get(this.scopedItem.item, this.config.subtitle.value)
        }
      }
      return this._.get(this.scopedItem.item, this.config.subtitle.value) || this.config.subtitle
    },
    additionalData() {
      if (!this.config || !this.config.additionalData) {
        return
      }
      return this.config.additionalData
    },
    wrappedListeners() {
      if (!this.config.listeners) {
        return null
      }
      return Object.keys(this.config.listeners || {}).reduce((acc, event) => {
        acc[event] = eventObj => this.config.listeners[event](this.scopedItem.item, eventObj)
        return acc
      }, {})
    }
  },
  methods: {
    handleValue(column, item) {
      if (column.valueFormatter && this._.isFunction(column.valueFormatter)) {
        return column.valueFormatter(item)
      }
      return item[column.value]
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  width: 100%;
  display: grid;
  grid-template-columns: 40px 1fr 26px;
  gap: 12px;
  align-items: center;

  &.no-icon {
    grid-template-columns: 1fr 26px;
  }
}
.icon-wrapper {
  width: 40px;
  height: 40px;

  border-radius: 12px;
  background: $background-secondary;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
